import { Typography } from "@material-ui/core";
import { KeyboardDatePicker, KeyboardDatePickerProps } from "@material-ui/pickers";
import dayjs from "dayjs";
import customParseFormat from 'dayjs/plugin/customParseFormat';
import React, { useState } from "react";

import { Mode } from "../../../utils/utility";

dayjs.extend(customParseFormat);

export interface DatePickerProps extends KeyboardDatePickerProps {
  mode: Mode;
  value: string | number | Date;
  onChange: (value: any) => void;
}

export const DatePicker = (props: DatePickerProps) => {
  // Props
  const {
    className,
    disabled,
    error,
    mode,
    onChange,
    value,
  } = props;

  // State
  const [selectedDate, handleDateChange] = useState(value ? dayjs(value).format(mode === Mode.Edit ? "YYYY-MM-DD" : "DD.MM.YYYY.") : null);

  // Options

  const isEmpty = value ? false : true;
  const internalClassName =
    "common-date-picker" +
    (error
      ? "--error"
      : disabled
        ? "--disabled"
        : "") +
    " common-date-picker" +
    (isEmpty ? "--empty" : "")
  ;

  switch (mode) {
    case Mode.View:
      return (
        <Typography variant="body1" color="primary" className={className}>
          {selectedDate}
        </Typography>
      );
    case Mode.Edit:
      return (
        <KeyboardDatePicker
          {...props}
          className={className + " " + internalClassName}
          autoOk
          clearable
          value={selectedDate}
          helperText={error}
          onChange={(
            date: any, value: any
          ) => {
            handleDateChange(date);

            const parsedDate = value instanceof Date ? dayjs(value) : dayjs(
              value,
              "DD.MM.YYYY"
            );

            if (parsedDate.isValid()) {
              onChange(parsedDate);
            }
          }}
        />
      );
    default:
      return null;
  }
};

DatePicker.defaultProps = {
  mode: Mode.Edit,
  inputVariant: "outlined",
}
